import type Organization from "entities/Organization.entity";

export const BREV_USER_MANAGEMENT_LABEL = "brev-user-management";

export function usesNcaUserManagement(
  organization: Pick<Organization, "ncaId" | "labels"> | null | undefined,
) {
  return (
    Boolean(organization?.ncaId) &&
    organization?.labels?.[BREV_USER_MANAGEMENT_LABEL] !== "true"
  );
}
